<script lang="ts">
	import { Icon } from '@repo/commons/components'
	import type { SvelteComponent } from 'svelte'

	type Props = {
		text: string
		icon?: typeof SvelteComponent | null
		onCloseClick?: (() => void) | null
	}

	let { text, icon = null, onCloseClick = null }: Props = $props()
</script>

<div class="tag">
	{#if icon}
		{@const Icon = icon}
		<Icon width="16" height="16" color="rgba(0, 44, 77, 0.50)" />
	{/if}
	<div class="text">
		{text}
	</div>
	{#if onCloseClick}
		<Icon name="close" size="sm" class="text-[#002C4D80]" />
	{/if}
</div>

<style>
	.tag {
		display: flex;
		height: 24px;
		padding: 0px 8px;
		justify-content: center;
		align-items: center;
		gap: 8px;
		border-radius: 16px;
		background: rgba(0, 73, 128, 0.06);
	}
	.text {
		color: rgba(0, 22, 38, 0.9);
		text-align: center;
		font-size: 14px;
		font-weight: 400;
		line-height: 20px;
	}
</style>
